import axios from "lib/axios";
import { callGet } from "./base";
import { compactHash } from "lib/utilities";

const UNREAD_URL = '/api/messaging/unread_messages'

function recentMessages({ page = null, per_page = 20, with_data = true } = {}) {
  const params = new URLSearchParams(compactHash({ page, per_page, no_data: !with_data }))

  return callGet(`${UNREAD_URL}?${params}`)
}

export default recentMessages